<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Extra Packaging</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" align="right" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-dropdown
            :disabled="selected.length === 0"
            id="dropdown-1"
            text="Action"
            :variant="selected.length === 0 ? 'primary':'warning'"
            class="m-md-2"
          >
            <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
            <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary" class="mr-2" @click="modalImage = !modalImage">
            <i class="fas fa-history mr-2"></i>Log
          </b-button>
          <router-link :to="{name: 'createExtraPackaging'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        hover
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        :items="getInfo"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
              :value="data"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th colspan="4"></b-th>
            <b-th colspan="3" class="text-center bg-gray-300 p-2">Size Extra Packaging</b-th>
            <b-th colspan="3"></b-th>
          </b-tr>
        </template>
        <template v-slot:cell(selected)="{ rowSelected}">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(price)="row">{{row.value | rupiah}}</template>
        <template v-slot:cell(title.id)="row">
          <div v-html="row.value.substring(0,20)"></div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editExtraPackaging', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <!-- <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>-->
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="modalImage" title="Preview Log" size="xl">
      <app-get-log></app-get-log>
    </b-modal>
  </div>
</template>

<script>
import getLog from "./component/getLog";

export default {
  components: {
    appGetLog: getLog
  },
  data() {
    return {
      modalImage: false,
      loading: false,
      errored: false,
      items: [],
      vuex: [],
      selected: [],

      key: [
        {
          key: "selected",
          class: "text-center"
        },
        {
          key: "created_at_date_only",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "name.id",
          label: "Name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "price",
          label: "Price",
          sortable: true,
          class: "text-center"
        },
        {
          key: "size.width",
          label: "Width",
          sortable: true,
          class: "text-center"
        },
        {
          key: "size.height",
          label: "Height",
          sortable: true,
          class: "text-center"
        },
        {
          key: "size.length",
          label: "Length",
          sortable: true,
          class: "text-center"
        },
        {
          key: "updated_at_date_only",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("ExtraPackagingModule/getExtraPackagings", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      const formData = new FormData();
      $.each(this.selected, (key, value) => {
        formData.append("extra_packaging_id", value.id);
        formData.append("status", status);
      });
      $.each(formData.getAll("extra_packaging_id"), (key, value) => {
        console.log(value);
      });

      this.loading = true;

      this.$store
        .dispatch("ExtraPackagingModule/updateExtraPackagings", formData)
        .then(response => {
          this.$refs.selectableTable.refresh();
          this.loading = false;
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1000
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.serverError = error.response;
          console.log(error);
        });
      // console.log(list);
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("ExtraPackagingModule/delExtraPackaging", id);
          this.$swal("Deleted!", "Your file has been deleted.", "success");
          this.$refs.selectableTable.refresh();
        }
      });
    }
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    }
  }
};
</script>

<style>
</style>
